import React from "react";
import { Link } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";

const NonAdminWelcomeBanner = ({ companyName, onDismiss }) => {
  return (
    <div
      role="region"
      aria-label="Welcome orientation"
      className="bg-bluegray border-l-4 border-lightblue rounded-md p-4 mb-4 relative"
    >
      {/* Dismiss button */}
      <button
        onClick={onDismiss}
        className="absolute top-3 right-3 text-lightgray hover:text-white"
        aria-label="Dismiss welcome banner"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>

      <p className="text-sm text-lightgray pr-8">
        Welcome to {companyName}! Your company already has active jobs. Explore them below or learn
        how CareerMission matching works.
      </p>

      <div className="flex items-center gap-4 mt-3 flex-wrap">
        <Link
          to="/employer-how-it-works"
          className="text-lightblue underline hover:text-orange text-sm"
        >
          How It Works
        </Link>
        <button
          onClick={onDismiss}
          className="bg-orange hover:bg-deeporange text-white font-bold py-2 px-4 rounded text-sm"
        >
          Start Exploring
        </button>
      </div>
    </div>
  );
};

export default NonAdminWelcomeBanner;
